// extracted by mini-css-extract-plugin
module.exports = {"body":"CatalogFolder_body__13kS4","title":"CatalogFolder_title__P88qM"};